import { render } from "./About.vue?vue&type=template&id=2503c4e1"
const script = {}
script.render = render

export default script